import CryptoJS from "crypto-js";
const SECRET_KEY = process.env.VUE_APP_SECRET_KEY;
const ivKey = process.env.VUE_APP_IV_TOKEN;

// Encrypt before storing
function EncryptData(data) {
  if (data) {  
    const key = CryptoJS.PBKDF2(SECRET_KEY, 'salt', { keySize: 256 / 32, iterations: 100 });
    const iv = CryptoJS.enc.Utf8.parse(ivKey);

    // Store as strings in localStorage
    // localStorage.setItem('FAT-TKN', CryptoJS.enc.Base64.stringify(key));
    // localStorage.setItem('FAT-Unknown', CryptoJS.enc.Base64.stringify(iv));

    const encrypted = CryptoJS.AES.encrypt(data, key, { iv: iv, mode: CryptoJS.mode.CBC });
    const encryptedHex = encrypted.ciphertext.toString(CryptoJS.enc.Hex);
    localStorage.setItem("FAT-Known", encryptedHex);

    return true;
  }
}

// Decrypt when retrieving
function DecryptData(encryptedHex) {
  if (encryptedHex) {
    // const keyStr = localStorage.getItem('FAT-TKN');
    // const ivStr = localStorage.getItem('FAT-Unknown');

    // if (!keyStr || !ivStr) return null;
    const key = CryptoJS.PBKDF2(SECRET_KEY, 'salt', { keySize: 256 / 32, iterations: 100 });
    const iv = CryptoJS.enc.Utf8.parse(ivKey);
    // Convert back to WordArray
    // const key = CryptoJS.enc.Base64.parse(keStr);
    // const iv = CryptoJS.enc.Base64.parse(ivStr);y

    const ciphertextWA = CryptoJS.enc.Hex.parse(encryptedHex);

    const decrypted = CryptoJS.AES.decrypt(
      { ciphertext: ciphertextWA },
      key,
      { iv: iv, mode: CryptoJS.mode.CBC }
    );

    return decrypted.toString(CryptoJS.enc.Utf8) || null;
  }
  return null;
}

function GetToken() {
  const encryptedHex = localStorage.getItem("FAT-Known");
  if (encryptedHex) {
    return DecryptData(encryptedHex);
  }
  return null;
}

function SaveToken(token) {
  if (token) {
    EncryptData(token);
  }
}

function ClearToken() {
  localStorage.removeItem("FAT-TKN");
  localStorage.removeItem("FAT-Unknown");
  localStorage.removeItem("FAT-Known");
}

export {GetToken, SaveToken, ClearToken}
